import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { resetPromoLog } from '~/services/PromoService';

type UseReferralLogResetProps = {
  referralLogId: string;
};

export default function useReferralLogReset({ referralLogId }: UseReferralLogResetProps) {
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: () => resetPromoLog(referralLogId),
    onSuccess: (response) => {
      if (response.status === 200) {
        enqueueSnackbar('Referral log reset', { variant: 'success' });
      } else {
        enqueueSnackbar(response.message || 'Failed to reset referral log', { variant: 'error' });
      }
    },
    onError: (err) => {
      enqueueSnackbar(`Error: ${JSON.stringify(err)}`, { variant: 'error', autoHideDuration: 5000 });
    },
  });

  return {
    referralLogId,
    isLoading: mutation.isPending,
    error: mutation.error,
    resetReferralLog: mutation.mutate,
  };
}
